export type CribnoshContentTypeLabel =
  | "video"
  | "recipe"
  | "story"
  | "live"
  | "meal"
  | "creator";

export type CribnoshVideoAction =
  | "make"
  | "post"
  | "watch"
  | "save"
  | "share"
  | "use"
  | "edit";

export const CRIBNOSH_SIZZLE_LABEL = "Sizzle";
export const CRIBNOSH_SIZZLES_LABEL = "Sizzles";

type LabelOptions = {
  plural?: boolean;
  lowercase?: boolean;
};

const toCase = (value: string, options?: LabelOptions) =>
  options?.lowercase ? value.toLowerCase() : value;

export const getCribnoshVideoLabel = (options?: LabelOptions) =>
  toCase(
    options?.plural ? CRIBNOSH_SIZZLES_LABEL : CRIBNOSH_SIZZLE_LABEL,
    options,
  );

export const getCribnoshVideoActionLabel = (
  action: CribnoshVideoAction,
  options?: LabelOptions,
) => {
  const noun = getCribnoshVideoLabel(options);
  switch (action) {
    case "make":
      return `Make ${noun}`;
    case "post":
      return `Post ${noun}`;
    case "watch":
      return `Watch ${options?.plural ? noun : getCribnoshVideoLabel({ plural: true, lowercase: options?.lowercase })}`;
    case "save":
      return `Save ${noun}`;
    case "share":
      return `Share ${noun}`;
    case "use":
      return `Use ${noun}`;
    case "edit":
      return `Edit ${noun}`;
    default:
      return noun;
  }
};

export const getCribnoshVideoBridgeCopy = (options?: { plural?: boolean }) =>
  options?.plural
    ? "Short food videos called Sizzles"
    : "A short food video called a Sizzle";

export const getCribnoshVideoShareTitle = () =>
  `Check out this ${getCribnoshVideoLabel({ lowercase: true })}`;

export const getCribnoshVideoShareMessage = () =>
  `Take a look at this Cribnosh ${getCribnoshVideoLabel({ lowercase: true })}.`;

export const getCribnoshContentTypeLabel = (
  type: CribnoshContentTypeLabel,
  options?: LabelOptions,
) => {
  switch (type) {
    case "video":
      return getCribnoshVideoLabel(options);
    case "recipe":
      return toCase(options?.plural ? "Recipes" : "Recipe", options);
    case "story":
      return toCase(options?.plural ? "Stories" : "Story", options);
    case "live":
      return toCase(options?.plural ? "Live sessions" : "Live", options);
    case "meal":
      return toCase(options?.plural ? "Meals" : "Meal", options);
    case "creator":
      return toCase(options?.plural ? "Creators" : "Creator", options);
    default:
      return toCase(options?.plural ? "Content" : "Content", options);
  }
};
